import React from "react";
import Collapsible from "react-collapsible";


class StatusTask extends React.Component {
    state = {
        task: [
            { profile: '/assets/images/avatar-voice-call.jpg', name: 'Corey Culhane', mag: 'New task completed successfully' }
        ],

        isOpen: {},
    }

    changeCollapse = (index) => {
        let isOpen = this.state.isOpen
        isOpen[index] = !isOpen[index]

        console.log('isOpen', isOpen)

        // console.log('isOpen[index]', isOpen[index])
        this.setState({ isOpen })
        console.log('!isOpen[index]', this.state.isOpen)
        // console.log('this.setState({isOpen})', this.setState({ isOpen }))
    }

    render() {
        return (
            <div className=' br-15 bg-white box-shadow-widgets p-2 '>
                <div className=' w-100'>
                    {this.state.task.map((prop, index) => {
                        return (
                            <>
                                <div className='' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div className='' style={{ display: 'flex' }}>
                                        <div className=' br-10 mrd-2 ' style={{ width: '45px' }}>
                                            <img className='br-10 w-100 h-100' src={prop.profile} alt="" />
                                        </div>
                                        <div className='flexc flex-1'>
                                            <div className='flex-1'>
                                                <p className='text-small'>{prop.name}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <p>30 min</p>
                                    </div>
                                </div>
                                <div style={{ borderBottom: '1px solid rgb(244, 245, 248)', margin: '9px 0' }} />
                                <div className="flexcb" style={{ alignItems: 'center', margin: '0 10px' }}>
                                    <div>
                                        <p style={{ fontSize:14 }}>{prop.mag}</p>
                                    </div>
                                    <div onClick={() => this.changeCollapse(index)} style={{ display: 'flex', alignItems: 'center' }}>


                                        {this.state.isOpen[index] == true ? (

                                            <img width={20} src='/images/icons/minus.png' />
                                        ) : (

                                            <img width={20} src='/images/icons/plus.png' />
                                        )}
                                        {/* <p style={{color:'#fff'}}><Texts question={text.question}/></p> */}
                                    </div>
                                    {/* <div className='w-100 h-100' style={{ marginBottom: 15 }}>

                                        <Collapsible open={this.state.isOpen[index]}  >
                                            <div className='w-100 h-100' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', }}>
                                                {prop.mag.map((data, index) => {
                                                    return (

                                                        <div>

                                                            <div>
                                                                <div>
                                                                    <p style={{ fontSize: 12, color: '#A5A5A5' }}>{data.text}</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    )
                                                })}
                                            </div>
                                        </Collapsible>

                                    </div> */}
                                </div>
                            </>
                        )
                    })}
                </div>

            </div>
        )
    }
}


export default StatusTask;